
import MenuPrincipal from './MenuPrincipal.js'
import { useEffect, useState } from 'react';
import { RutaLocal, Ruta, ConsultaData } from '../componentes/funcionesEspeciales.js';
import Modal from 'react-bootstrap/Modal'
import Dropdown from 'react-bootstrap/Dropdown';
import swal from 'sweetalert';
import logo from '../media/img/logo_sin_fondo.png'
function Header({ cantidadItems, precioTotalItems }) {
    const [telefonos, setTelefonos] = useState({
        fijo: '',
        movil: ''
    })
    const [codigoEnviado, setCodigoEnviado] = useState("")
    const [usuario, setUsuario] = useState({
        id: 0,
        email: '',
        codigo_email: '',
        contrasena: '',
        repetir_contrasena: '',
        nombres: '',
        apellidos: '',
        fecha_nacimiento: '',
        id_distrito: 0,
        direccion: '',
        celular: '',
        dni: '',
        es_nuevo: false
    })
    const [distritos, setDistritos] = useState([])
    const getDistritos = () => {
        ConsultaData('?/web/getDistritos').then(response => { setDistritos(response) })
    }
    useEffect(() => {
        getDistritos()
    }, [])
    const manejadorUsuario = (e) => {
        const { name, value } = e.target
        setUsuario({ ...usuario, [name]: value })
    }
    const validarNuevo = () => {
        if (usuario.email == "" || usuario.nombres == "") {
            alert("Debe complete campos de email y nombres")
            return false
        }
        if (!usuario.email.match(
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )) {
            alert("ingrese email válido")
            return false
        }
        if (usuario.id_distrito == 0 || usuario.direccion == "") {
            alert("Seleccione un distrito y dirección")
            return false
        }
        if (usuario.contrasena == "" || usuario.contrasena.length < 8) {
            alert("Ingrese contrasena mayor de al menos 8 caracteres!!")
            return false
        }
        if (usuario.contrasena != usuario.repetir_contrasena) {
            alert("Las contraseñas no coinciden!")
            return false
        }
        return true
    }
    const registrarse = () => {
        if (!validarNuevo()) return
        ConsultaData("?/web/createCliente", usuario, "POST").then(respuesta => {
            if (respuesta["response"]) {
                localStorage.setItem("token_web", respuesta.token)
                //window.location.href = "/tienda"
                //location.reload()
                window.location.reload();
            } else {
                alert(respuesta["mensaje"])
            }
        })
    }
    //const sleep = ms => new Promise(r => setTimeout(r, ms));
    const sleep = (milliseconds) => {
        return new Promise(resolve => setTimeout(resolve, milliseconds))
    }
    const iniciarSesion = async () => {
        ConsultaData("?/web/iniciarSesion", usuario, "POST").then(respuesta => {
            if (respuesta["response"]) {
                localStorage.setItem("token_web", respuesta.token)
                window.location.reload();
                /*sleep(1100).then(r => {
                    //window.location.reload();
                    revisarSesion(respuesta.token)
                })*/
            } else {
                swal({
                    title: "Error!",
                    text: respuesta["mensaje"],
                    icon: "error",
                    button: "Aceptar",
                    className: "sobre_todo"
                })
            }
        })
    }
    const cerrarSesion = () => {
        /*ConsultaData("?/web/cerrarSesion").then(respuesta => {
            if (respuesta["response"]) {
                localStorage.removeItem("token_web")
                window.location.reload();
            }
        })*/
        localStorage.removeItem("token_web")
        window.location.reload();
    }
    const validarNuevoUsuario = () => {
        if (usuario.email == "" || usuario.contrasena == "" || usuario.nombres == "" || usuario.apellidos == "" || usuario.fecha_nacimiento == "" || usuario.id_distrito == 0 || usuario.direccion == "") {
            alert("Todos los campos son obligatorios")
            return false
        }
        return true
    }
    const crearNuevoUsuario = () => {
        ConsultaData("guardar", usuario).then(respuesta => {
            if (respuesta.status == 200) {
                setCodigoEnviado(respuesta.data.codigo_email)
                setModalLogin(true)
            }
        })
    }
    const [modalLogin, setModalLogin] = useState(false)
    const toggleModal = () => setModalLogin(!modalLogin)
    const revisarSesion = async (tok = "") => {
        //console.log("voy a revisarrrr", localStorage.getItem("token_web"), tok)
        const cuerpo = {
            method: "POST",
            headers: {
                'Authorization': tok,
            },
            body: JSON.stringify({ token: tok }),
        }
        await fetch(Ruta + "?/web/revisarSesion", cuerpo)
            .then(response => response.json())
            .then(respuesta => {
                if (respuesta["response"]) {
                    setUsuario({
                        ...usuario,
                        id: respuesta["id"],
                        email: respuesta["email"],
                        nombres: respuesta["nombres"],
                    })
                } else {
                    localStorage.removeItem("token_web")//estoy esta causando paltasss
                    //localStorage.setItem("token_web","maldicionnn")
                    limpiarUser()
                }
            })
            .catch(error => {
                alert("Recargar lista o pagina")
            })
        /*ConsultaData("?/web/reS").then(respuesta => {
            if (respuesta["response"]) {
                setUsuario({
                    ...usuario,
                    id: respuesta["id"],
                    email: respuesta["email"],
                    nombres: respuesta["nombres"],
                })
            } else {
                localStorage.removeItem("token_web")//estoy esta causando paltasss
                //localStorage.setItem("token_web","maldicionnn")
                limpiarUser()
            }
        })*/
    }
    const limpiarUser = () => {
        setUsuario({
            id: 0,
            email: '',
            codigo_email: '',
            contrasena: '',
            repetir_contrasena: '',
            nombres: '',
            apellidos: '',
            fecha_nacimiento: '',
            id_distrito: 0,
            direccion: '',
            celular: '',
            dni: '',
            es_nuevo: false
        })
    }
    useEffect(() => {
        revisarSesion(localStorage.getItem("token_web"))
    }, [])
    return (<>
        <div id="header-wrap">
            <div className="">
                <div className="d-flex flex-column flex-md-row justify-content-between">
                    <div className='d-flex align-items-center gap-2 flex-fill'>
                        <div className="">
                            <a href="/" className="">
                                <img className='bg-light' height={"auto"} width={100} src={logo} />
                            </a>
                        </div>
                        <button className='btn btn-primary d-flex gap-2 align-items-center ms-auto'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-telephone-fill" viewBox="0 0 16 16">
                                <path fillRule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
                            </svg>
                            (054) 424087
                        </button>
                        <button className='btn btn-primary d-flex gap-2 align-items-center'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-whatsapp" viewBox="0 0 16 16">
                                <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
                            </svg>
                            (+51) 959375800
                        </button>
                    </div>
                    <div className='d-flex align-items-center gap-2'>
                        <div className="text-links coupon-top col">
                            {usuario.id != 0 ?
                                <><div className="auth-link float-right openOTPPopUp ml-3 d-flex">
                                    Hola
                                    <Dropdown style={{ zIndex: 9999 }}>
                                        <Dropdown.Toggle className='btn btn-sm btn-secondary' id="dropdown-basic">
                                            {usuario.nombres}
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu style={{ zIndex: 9999 }}>
                                            <Dropdown.Item href="#" onClick={cerrarSesion}>Cerrar Sesión</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                                </> :
                                <a className="auth-link float-right openOTPPopUp ml-3" href={"#"} onClick={toggleModal} >Iniciar Sesion </a>
                            }
                            <a className="auth-link float-right openOTPPopUp mr-3" href={RutaLocal + "carrito"}>Ver Carrito</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <MenuPrincipal cantidad={cantidadItems} precio={precioTotalItems} />
        <Modal show={modalLogin} onHide={toggleModal} size="md" style={{ zIndex: "9999" }}>
            <Modal.Header closeButton>
                <Modal.Title>Inicie Sesión</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <hr />
                <center>
                    <h4>
                        {usuario.es_nuevo ? "Regístrate" : "Inicie Sesión"}
                    </h4>
                </center><br />
                <div className="row form-group">
                    <label className="control-label col-md-4">Email</label>
                    <div className="col-md-8">
                        <input type="email" className="form-control " name="email"
                            value={usuario.email} placeholder="email" onChange={manejadorUsuario} />
                    </div>
                </div>
                {usuario.es_nuevo &&
                    <>
                        <div className="row form-group">
                            <label className="control-label col-md-4">Nombres <span className='obligatorio'>*</span></label>
                            <div className="col-md-8">
                                <input maxLength="100" type="text" className="form-control " name="nombres"
                                    value={usuario.nombres} placeholder="nombres" onChange={manejadorUsuario} />
                            </div>
                        </div>
                        <br />
                        <div className="row form-group">
                            <label className="control-label col-md-4">Apellidos <span className='obligatorio'>*</span></label>
                            <div className="col-md-8">
                                <input maxLength="100" type="text" className="form-control " name="apellidos"
                                    value={usuario.apellidos} placeholder="Apellidos" onChange={manejadorUsuario} />
                            </div>
                        </div>
                        <br />
                        <div className="row form-group">
                            <label className="control-label col-md-4">Distrito <span className='obligatorio'>*</span></label>
                            <div className="col-md-8">
                                <select className="form-control " name="id_distrito"
                                    value={usuario.id_distrito} onChange={manejadorUsuario} >
                                    <option value={""}>Seleccione</option>
                                    {distritos.map((item, key) => (
                                        <option key={key} value={item.idDist}>{item.distrito}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="row form-group" style={{ display: "none" }}>
                            <label className="control-label col-md-4">DNI <span className='obligatorio'>*</span></label>
                            <div className="col-md-8">
                                <input maxLength="50" type="text" className="form-control " name="dni"
                                    value={usuario.dni} placeholder="dni" onChange={manejadorUsuario} />
                            </div>
                        </div>
                        <div className="row form-group">
                            <label className="control-label col-md-4">Celular <span className='obligatorio'>*</span></label>
                            <div className="col-md-8">
                                <input maxLength="50" type="text" className="form-control " name="celular"
                                    value={usuario.celular} placeholder="celular" onChange={manejadorUsuario} />
                            </div>
                        </div>
                        <div className="row form-group">
                            <label className="control-label col-md-4">Dirección <span className='obligatorio'>*</span></label>
                            <div className="col-md-8">
                                <input maxLength="200" type="text" className="form-control " name="direccion"
                                    value={usuario.direccion} placeholder="direccion" onChange={manejadorUsuario} />
                            </div>
                        </div>
                        <br />
                        <div className="row form-group">
                            <label className="control-label col-md-4">Fecha Nacimiento <span className='obligatorio'>*</span></label>
                            <div className="col-md-8">
                                <input type="date" className="form-control " name="fecha_nacimiento"
                                    value={usuario.fecha_nacimiento} placeholder="fecha_nacimiento" onChange={manejadorUsuario} />
                            </div>
                        </div>
                        <br />
                    </>}

                <div className="row form-group">
                    <label className="control-label col-md-4">Contraseña</label>
                    <div className="col-md-8">
                        <input type="password" className="form-control " name="contrasena"
                            value={usuario.contrasena} onChange={manejadorUsuario} />
                    </div>
                </div><br />
                {usuario.es_nuevo &&
                    <><div className="row form-group">
                        <label className="control-label col-md-4">Repetir Contraseña</label>
                        <div className="col-md-8">
                            <input type="password" className="form-control " name="repetir_contrasena"
                                value={usuario.repetir_contrasena} onChange={manejadorUsuario} />
                        </div>
                    </div><br />
                    </>
                }
                <div className="row form-group center text-center">
                    <div className="col-md-12">
                        <button className="btn btn-primary btn-sm " onClick={() => usuario.es_nuevo ? registrarse() : iniciarSesion()}>
                            {usuario.es_nuevo ? "Registrarse" : "Iniciar Sesion"}
                        </button>
                    </div>
                </div>
                <div className="row form-group center text-center">
                    <div className="col-md-12">
                        {usuario.es_nuevo ?
                            <a className="" style={{ textDecoration: "underline", color: "blue" }}
                                onClick={() => setUsuario({ ...usuario, es_nuevo: false })}>Ingresar con mi Cuenta</a>
                            :
                            <a className="" style={{ textDecoration: "underline", color: "blue", cursor: "pointer" }}
                                onClick={() => setUsuario({ ...usuario, es_nuevo: true })}>Crear Nueva Cuenta</a>
                        }
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                {":)"}
            </Modal.Footer>
        </Modal >
    </>)
}
export default Header;